import { render, staticRenderFns } from "./FeedCard.vue?vue&type=template&id=4ded01b9"
import script from "./FeedCard.vue?vue&type=script&lang=ts"
export * from "./FeedCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports